export default __webpack_public_path__ + "static/media/ErrorExclamation.aa002763.svg";